export const getFullUrl = (url: string): string =>
    url.startsWith('http') ? url : `https://${url}`;
